import replaceInvertedQuotes from 'components/Dashboard/utilities/replaceInvertedQuotes';

const addQuotesToString = (query) => {
  const cleanedQuery = replaceInvertedQuotes(query);
  if (cleanedQuery.startsWith('"') && cleanedQuery.endsWith('"')) {
    return cleanedQuery;
  } else {
    return `"${cleanedQuery}"`;
  }
};

export default addQuotesToString;
